import { render, staticRenderFns } from "./JianFa.vue?vue&type=template&id=6e812c36&scoped=true"
import script from "./JianFa.vue?vue&type=script&lang=js"
export * from "./JianFa.vue?vue&type=script&lang=js"
import style0 from "./JianFa.vue?vue&type=style&index=0&id=6e812c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e812c36",
  null
  
)

export default component.exports